module.exports = __webpack_public_path__ + "static/img/org-guide.61878c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/org-guide.png
// module id = 731
// module chunks = 8